const MIN_LENGTH = 8;

const validate = (values) => {
  const errors = {};

  if (!values.password || values.password.length < MIN_LENGTH) {
    errors.password = { invalidLength: true };
  }

  if (!values.password_confirmation || values.password !== values.password_confirmation) {
    errors.password_confirmation = true;
  }

  return errors;
};

export default validate;
